<template>
  <div class="home">
    <div class="cont1 cont clearfix">
      <slider :list="lunbo"></slider>
      <common-list class="c-list" :list="zhuixintuijian" title="推荐"></common-list>
    </div>
    <div class="cont2 cont">
      <div class="activity">
        <s-header linkto="/activity" title="活动"></s-header>
        <ul class="img-list">
          <li v-for="item in huodong" :key="item.id" @click="toArticleDetail(item.id)">
            <div class="cont2_img"><img :src="item.path" :alt="item.title" srcset=""></div>
            <div class="img_title">{{item.title}}</div>
          </li>
        </ul>
      </div>
      <common-list class="c-list" :list="shipin" linkto="/video" title="视频" :img-index="[0]"></common-list>
    </div>
    <div class="banner cont">
      <a target="_blank" :href="banner.url">
        <img :src="banner.image" :alt="banner.title" :title="banner.title" srcset="">
      </a>
    </div>
    <div class="cont3 cont">
      <s-header linkto="/character"  title="人物"></s-header>
      <ul class="character-list">
        <li v-for="item in renwu" :key="item.id" @click="toChaDetail(item.id)">
          <div class="photo left"><img :src="item.path" :alt="item.name" :title="item.name" srcset=""></div>
          <div class="info left">
            <div class="name">{{item.title}}</div>
            <div class="position">艺术家</div>
            <div class="desc">{{item.description.substr(0, 50)}}...</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="clear"></div>
    <div class="cont4 cont">
      <div class="activity">
        <s-header linkto="/calligraphy" title="书法"></s-header>
        <ul class="img-list">
          <li v-for="item in shufa" :key="item.id" @click="toArticleDetail(item.id)">
            <div class="cont2_img"><img :src="item.path" :alt="item.title" srcset=""></div>
            <div class="img_title">{{item.title}}</div>
          </li>
        </ul>

        <s-header linkto="/painting" title="国画"></s-header>
        <ul class="img-list">
          <li v-for="item in guohua" :key="item.id" @click="toArticleDetail(item.id)">
            <div class="cont2_img"><img :src="item.path" :alt="item.title" srcset=""></div>
            <div class="img_title">{{item.title}}</div>
          </li>
        </ul>
      </div>
      <div>
      <common-list class="c-list" :list="mingzuo" linkto="/masterwork" title="名作" :img-index="[0,3]"></common-list>
      </div>
    </div>
      <!-- 跑马灯 -->
    <marquee :list="gundong1"></marquee>
    <!-- 鉴赏 -->
    <div class="cont5 cont">
      <s-header linkto="/appreciate" title="鉴赏"></s-header>
      <ul>
        <li v-for="item in jianshang" :key="item.id" class="left" @click="toArticleDetail(item.id)">
            <img :src="item.path" alt="" srcset="">
            <span>{{item.title}}</span>
        </li>
      </ul>
    </div>
    <div class="cont6 cont">
       <common-list class="l-list" :list="zhishi" linkto="/knowledge" title="知识"></common-list>
       <div class="zongyi">
         <s-header linkto="/show" title="综艺"></s-header>
          <ul>
            <li v-for="item in zongyi" :key="item.id" @click="toArticleDetail(item.id)">
              <div class="top">
                <img :src="item.path" alt="" srcset="">
                <span>{{item.title}}</span>
              </div>
              <div class="clear"></div>
              <div class="bottom">
                {{item.title}}
              </div>
            </li>
          </ul>
       </div>
    </div>
    <div class="clear"></div>
    <marquee class="marquee2" :list="gundong2"></marquee>
    <n-footer></n-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import slider from '@/components/Swiper/Index.vue'
import CommonList from './CommonList/Index.vue'
import SHeader from './SHeader/Index.vue'
import Marquee from '@/components/Marquee/Index.vue'
import nFooter from '@/components/Footer/Index.vue'

export default {
  name: 'Home',
  components: {
    slider,
    CommonList,
    SHeader,
    Marquee,
    nFooter
  },
  data () {
    return {
      banner: {},
      lunbo: [],
      zhuixintuijian: [],
      huodong: [],
      shipin: [],
      renwu: [],
      shufa: [],
      guohua: [],
      mingzuo: [],
      jianshang: [],
      zhishi: [],
      zongyi: [],
      gundong1: [],
      gundong2: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      const _this = this
      // 为给定 ID 的 user 创建请求
      this.$http.get('/Index/list')
        .then(function (response) {
          if (response.data.status === 0) {
            const {
              banner, lunbo, zhuixintuijian, huodong, shipin,
              renwu, shufa, guohua, mingzuo, jianshang, zhishi,
              zongyi, gundong1, gundong2
            } = response.data.data

            _this.banner = banner
            _this.lunbo = lunbo
            _this.zhuixintuijian = zhuixintuijian
            _this.huodong = huodong
            _this.shipin = shipin
            _this.renwu = renwu
            _this.shufa = shufa
            _this.guohua = guohua
            _this.mingzuo = mingzuo
            _this.jianshang = jianshang
            _this.zhishi = zhishi
            _this.zongyi = zongyi.slice(0, 2)
            _this.gundong1 = gundong1
            _this.gundong2 = gundong2
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    toArticleDetail(id) {
      let {href} = this.$router.resolve({path: `/a-detail?id=${id}`})
      window.open(href, '_blank')
    },
    toChaDetail(id) {
      let {href} = this.$router.resolve({path: `/c-detail?id=${id}`})
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
li {
  cursor: pointer;
}
.recommendPage {
  width: 710px;
  float: left;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover; 
  }
}
.c-list {
  float: left;
  margin-left: 30px;
}
.l-list {
  float: left;
}
.cont {
  max-width: 980px;
  margin: 0 auto;
}
.cont1 {
  height: 320px;
}
.cont2, .cont4 {
  height: 470px;
  overflow: hidden;
  .activity {
    width: 710px;
    float: left;
  }
  .img-list {
    margin-top: 20px;
    li {
      display: inline-block;
      width: 222px;
      margin-right: 21px;
      margin-bottom: 15px;
      .cont2_img {
        height: 146px;
        border-radius: 4px;
        overflow: hidden;
      }
      .img_title {
        height: 40px;
        margin: 12px 0;
        font-size: 14px;
        color: #222;
        overflow: hidden;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner {
  margin: 20px auto;
  a {
    display: inline-block;
    width: 100%;
  }
}
.cont3 {
  .character-list {
    .left {
      float: left;
    }
    li {
      float: left;
      width: 310px;
      margin-right: 20px;
      margin-bottom: 25px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .photo {
        width: 108px;
        height: 108px;
        margin-top: 10px;
        border-radius: 50%;
        overflow: hidden;
      }
      .info {
        width: 180px;
        margin-left: 10px;
        .name {
          font-size: 20px;
        }
        .position {
          font-size: 16px;
          margin: 10px 0;
          color: #999;
        }
        .desc {
          font-size: 14px;
          text-align: justify;
        }
      }
    }
  }
}
.clear {
  clear: both;
}
.cont5 {
  margin-top: 22px;
  ul {
    margin-top: 22px;
    li {
      float: left;
      position: relative;
      width: 232px;
      height: 150px;
      margin-bottom: 22px;
      margin-right: 16px;
      border-radius: 10px;
      overflow: hidden;
      &:nth-child(1) {
        width: 720px;
        height: 320px;
        margin-right: 26px;
        span {
          font-size: 20px;
        }
      }
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(7) {
        margin-right: 0;
      }
      span {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: rgba(0,0,0,0.4);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.cont6 {
  margin-bottom: 20px;
  .zongyi {
    float: left;
    width: 710px;
    margin-left: 26px;
    ul {
      li {
        float: left;
        width: 320px;
        &:nth-child(1) {
          margin-right: 60px;
        }
        .top {
          width: 100%;
          height: 160px;
          img {
            float: left;
            width: 140px;
            height: 140px;
            border-radius: 10px;
            margin-right: 20px;
          }
          span {
            float: left;
            width: 140px;
            margin-top: 35px;
            font-size: 16px;
          }
        }
        .bottom {
          font-size: 16px;
        }
      }
    }
  }
}
.marquee2 {
  margin: 20px auto;
}
</style>
